module.exports = __webpack_public_path__ + "static/media/login.26f5d122.png";